import { Empty } from 'antd';
import styled from 'styled-components';

export default styled(Empty)`
	// Add your styles here
`;
